import Icon from '@/Shared/Icon';
export default {
  components: {
    Icon: Icon
  },
  emits: ['restore']
};